import { Component, Input, inject, signal } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { OrderShipment } from "src/app/models/order-shipment";
import { HardDriveMetadataServiceService } from "../../services";
import { MetadataOrderType, OrderType } from "src/app/models/enums";
import { ToastrService } from "ngx-toastr";
import { MatProgressSpinner } from "@angular/material/progress-spinner";
import { MatIconModule } from "@angular/material/icon";
import { MatTooltipModule } from "@angular/material/tooltip";

@Component({
  selector: 'download-metadata-button',
  templateUrl: './download-metadata-button.component.html',
  styleUrls: ['./download-metadata-button.component.scss'],
  providers: [],
  imports: [
    MatButtonModule,
    MatIconModule,
    MatProgressSpinner,
    MatTooltipModule
  ],
  standalone: true
})
export class DownloadMetadataButtonComponent {
  @Input() orderShipment: OrderShipment;
  public isGettingMetadata = signal<boolean>(false);

  // Injected services
  private hardDriveMetadataService = inject(HardDriveMetadataServiceService);
  private toastr = inject(ToastrService);

  public async downloadOrderShipmentMetadata(): Promise<void> {
    const metadataOrderType = this.getMetadataOrderType(this.orderShipment.orderType, this.orderShipment.drmType);
    if (metadataOrderType == null) {
      this.toastr.error('Order type and drm type are not a valid combination for this order shipment', 'Error');
      return;
    }

    this.isGettingMetadata.set(true);
    await this.hardDriveMetadataService
      .downloadHardDriveMetadata(this.orderShipment.orderNumber, this.orderShipment.shipmentNumber, metadataOrderType)
      .finally(() => this.isGettingMetadata.set(false));
  }

  private getMetadataOrderType(orderType: OrderType, drmType: string): MetadataOrderType | null {
    if (orderType === OrderType.Adebs) {
      // a few variations in ADEBs orders with DRM types
      if (drmType) {
        if (drmType.toLowerCase() === 'proidiom') {
          return MetadataOrderType.AdebsProIdiom;
        }
        if (drmType.toLowerCase() === 'samsung lynk') {
          return MetadataOrderType.AdebsSamsungLynk;
        }
      }

      return MetadataOrderType.Adebs;
    }

    if (orderType === OrderType.StreamingServer) {
      return MetadataOrderType.Streaming;
    }

    if (orderType === OrderType.Cinelink) {
      return MetadataOrderType.Cinelink;
    }

    return null;
  }
}
